import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from '../../lib/utils'

const textareaVariants = cva(
  "flex min-h-[80px] w-full border border-input bg-transparent px-3 py-2 text-body shadow-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
  {
    variants: {
      inputSize: {
        sm: "min-h-[64px] px-2.5 py-1.5 text-body-sm",
        default: "min-h-[80px] px-3 py-2",
        lg: "min-h-[96px] px-3.5 py-2.5",
      },
      variant: {
        default: "rounded-lg",
        ghostInline:
          "min-h-0 rounded-none border-0 bg-transparent p-0 shadow-none focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0",
      },
    },
    defaultVariants: {
      inputSize: "default",
      variant: "default",
    },
  }
)

export type TextareaProps = React.ComponentProps<"textarea"> &
  VariantProps<typeof textareaVariants>

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, inputSize, variant, ...props }, ref) => {
    return (
      <textarea
        className={cn(textareaVariants({ inputSize, variant, className }))}
        ref={ref}
        {...props}
      />
    )
  }
)
Textarea.displayName = "Textarea"

export { Textarea, textareaVariants }
